var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videowrapper"},[_c('iframe',{attrs:{"width":"560","height":"315","src":("https://www.youtube.com/embed/" + _vm.videoId),"allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }